import { MOOD_LEVELS } from "../lib/config";

const W = 150;
const H = 42;

// -10..+10 mood coil: rings widen toward the extremes.
export function MoodVortex({ value, onChange }) {
  return (
    <div className="flex flex-col items-start py-2" data-testid="mood-vortex">
      {MOOD_LEVELS.map((lvl, i) => {
        const sel = value === lvl.value;
        const cx = W / 2 + Math.sin(i * 0.78) * 30;
        const k = Math.abs(lvl.value) / 10;
        return (
          <button key={lvl.value} type="button" onClick={() => onChange(lvl.value)} data-testid={`mood-${lvl.value}`}
            className={`flex items-center gap-3 group ${i === 0 ? "" : "-mt-[14px]"}`}>
            <svg width={W} height={H} className="shrink-0 transition-transform duration-200 group-hover:scale-[1.04]">
              <ellipse cx={cx} cy={H / 2} rx={20 + k * 42} ry={6.5 + k * 10} stroke={lvl.color} strokeWidth={sel ? 6 : 3} fill={sel ? lvl.color : "transparent"} />
            </svg>
            <span className="w-8 text-right font-bold text-[15px]" style={{ color: lvl.color }}>{lvl.value > 0 ? `+${lvl.value}` : lvl.value}</span>
            <span className="text-left leading-tight">
              <span className={`underline underline-offset-2 text-[15px] ${sel ? "font-bold text-t-on" : "text-t-on2"}`}>{lvl.label}</span>
              {sel ? <span className="block text-[13px] text-t-muted">{lvl.descriptor}</span> : null}
            </span>
          </button>
        );
      })}
    </div>
  );
}
